import { signal } from 'services/SignalsService'

export default class BetModel {
  constructor() {
    this._bets = []
    this._id = 0
    this._adjustmentBuy = false

    this.createSignal()
  }

  createSignal() {
    signal.on('BUTTON:prevbet', this.makeHandler(-1))
    signal.on('BUTTON:nextbet', this.makeHandler(1))
    signal.on('BUTTON:maxbet', this.makeHandler(666))

    signal.on('BET:bet', (id) => {
      this.setID(id)
    })

    signal.on('BUTTON:BuyButton', () => {
      this.setAdjustmentBuy(true)
    })
    signal.on('BUTTON:spin', () => {
      this.setAdjustmentBuy(false)
    } )
  }

  setAdjustmentBuy(value) {
    this._adjustmentBuy = value
  }

  makeHandler(delta) {
    const self = this

    return function () {
      self.setID(self._id + delta)
    }
  }

  setNearest(value) {
    const multiplier = game.models.SpinModel.get().buy[0]
    if(game.models.SpinModel.get().buy.length > 0 && this._adjustmentBuy){
      this.setID(this._bets.reduce((acc, curr, idx) => (curr * multiplier) <= value ? idx : acc, 0))
    }
    else{
      this.setID(this._bets.reduce((acc, curr, idx) => curr <= value ? idx : acc, 0))
    }

  }

  setList(value) {
    this._bets = value
  }

  getList() {
    return this._bets
  }

  setValue(value) {
    this.setID(this._bets.findIndex((bet) => bet == value))
  }

  setID(value) {
    this._id = value < 0 ? 0 : value > this.getMaxID() ? this.getMaxID() : value
    signal.dispatch('MODEL:BET', this.getValue())
  }

  getID() {
    return this._id
  }

  getMaxID() {
    return this._bets.length - 1
  }

  getValue() {
    return this._bets[this._id]
  }

  getMinValue() {
    return this._bets[0]
  }

}
